// Plateforme électronique ("PA") utilisée par le client — liste appelée à
// grandir : ajouter une valeur ici suffit, aucune migration nécessaire
// (le champ Client.plateformeElectronique est un simple String? en base).
// Triée par ordre alphabétique à l'export (selects de la fiche client et page
// Identifiants PA) : une nouvelle valeur peut être ajoutée n'importe où.
export const PLATEFORME_ELECTRONIQUE_OPTIONS = [
  "MEG",
  "DEXT",
  "Pennylane",
  "Qonto",
  "Axonaut",
  "MyAlfa Link",
  "Tiime Free",
  "INDY",
  "HENRRI",
  "EBP",
  "SAGE",
  "PROGBAT",
  "CONSTRUCTYS",
  "FACTURE.NET",
  "IPAIDTHAT",
  "KLEKOON",
  "DOCOON",
  "Kolecto",
  "SHINE",
  "B2Router",
  "SuperPDP",
  "ESALINK",
  "VOSFACTURES",
  "EVOLIZ",
  "DOUGS",
  "My Komela",
  "Odoo",
  "Iopole",
  "CECURITY.COM",
  "GAD GARAGE",
  "ABBY",
].sort((a, b) => a.localeCompare(b, "fr", { sensitivity: "base" }));

// Logos servis depuis public/logos-pa/ (pas d'import statique nécessaire —
// nouvelle valeur = juste ajouter le fichier + l'entrée ici, sans recompiler
// de logique). Une valeur sans logo ici retombe simplement sur le nom texte
// (voir Portefeuille.js / FicheClientOverlay.js).
// Noms de fichiers et extensions tels que réellement déposés dans
// public/logos-pa/ (formats mixtes png/jpg/jpeg/webp, et "Dext.webp" avec
// une majuscule) — la casse compte une fois déployé (hébergement Linux).
export const PLATEFORME_ELECTRONIQUE_LOGOS = {
  MEG: "/logos-pa/meg.jpg",
  DEXT: "/logos-pa/Dext.webp",
  Pennylane: "/logos-pa/pennylane.png",
  Qonto: "/logos-pa/qonto.png",
  Axonaut: "/logos-pa/axonaut.jpeg",
  "MyAlfa Link": "/logos-pa/myalfa-link.jpg",
  "Tiime Free": "/logos-pa/tiime%20free.png",
  INDY: "/logos-pa/indy.png",
  HENRRI: "/logos-pa/henrri.jpg",
  EBP: "/logos-pa/EBP.png",
  SAGE: "/logos-pa/Sage.png",
  PROGBAT: "/logos-pa/PROGBAT.jpg",
  CONSTRUCTYS: "/logos-pa/CONSTRUCTYS.jpg",
  "FACTURE.NET": "/logos-pa/FACTURE.NET.jpg",
  IPAIDTHAT: "/logos-pa/IPAIDTHAT.png",
  KLEKOON: "/logos-pa/KLEKOON.png",
  DOCOON: "/logos-pa/DOCOON.jpg",
  Kolecto: "/logos-pa/Kolecto.png",
  SHINE: "/logos-pa/Shine.png",
  B2Router: "/logos-pa/B2Router.png",
  SuperPDP: "/logos-pa/SuperPDP.png",
  ESALINK: "/logos-pa/ESALINK.png",
  VOSFACTURES: "/logos-pa/VOSFACTURES.jpg",
  EVOLIZ: "/logos-pa/EVOLIZ.png",
  DOUGS: "/logos-pa/DOUGS.png",
  "My Komela": "/logos-pa/My%20Komela.jpg",
  // Seul logo au format SVG à ce jour — rendu sans souci par la balise <img>
  // de PlateformeLogo.js, comme les png/jpg/webp.
  Odoo: "/logos-pa/Odoo.svg",
  Iopole: "/logos-pa/iopole.png",
  "CECURITY.COM": "/logos-pa/CECURITY.COM.png",
  "GAD GARAGE": "/logos-pa/GAD%20GARAGE.png",
  ABBY: "/logos-pa/ABBY.png",
};
